import { render, staticRenderFns } from "./AdminNavigation.vue?vue&type=template&id=af375256&scoped=true"
import script from "./AdminNavigation.vue?vue&type=script&lang=js"
export * from "./AdminNavigation.vue?vue&type=script&lang=js"
import style0 from "./AdminNavigation.vue?vue&type=style&index=0&id=af375256&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af375256",
  null
  
)

export default component.exports